import Divider from 'components/Luxkit/Divider'
import LineExclamationCircleIcon from 'components/Luxkit/Icons/line/LineExclamationCircleIcon'
import LineExclamationTriangleIcon from 'components/Luxkit/Icons/line/LineExclamationTriangleIcon'
import LineTagAltIcon from 'components/Luxkit/Icons/line/LineTagAltIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import React, { ReactNode, useMemo } from 'react'

type AccommodationRoomTileKnownMessage =
  'loading' |
  'members-exclusive' |
  'sold-out-on-dates' |
  'sold-out' |
  'exceeded-capacity' |
  'sold-out-on-dates-or-exceeded-capacity' |
  'available-on-dates'

interface Props {
  message: AccommodationRoomTileKnownMessage
  offer: App.HotelOffer
}

function AccommodationRoomTileMessage(props: Props) {
  const {
    message,
    offer,
  } = props

  const messageLabel = useMemo<{ text: ReactNode, icon?: ReactNode } | undefined>(() => {
    switch (message) {
      case 'members-exclusive':
        return {
          text: 'Sign up to access exclusive rates',
          icon: <LineTagAltIcon />,
        }
      case 'sold-out-on-dates':
        return {
          text: `This ${offer.saleUnitLong} is sold out on your dates`,
          icon: <LineExclamationCircleIcon />,
        }
      case 'sold-out':
        return {
          text: `This ${offer.saleUnitLong} is sold out`,
          icon: <LineExclamationCircleIcon />,
        }
      case 'exceeded-capacity':
        return {
          text: 'Max number of guests exceeded',
          icon: <LineExclamationTriangleIcon />,
        }
      case 'sold-out-on-dates-or-exceeded-capacity':
        return {
          text: <>This room is sold out on your dates or <br />
            Max number of guests exceeded
          </>,
          icon: <LineExclamationCircleIcon />,
        }
    }
  }, [message, offer.saleUnitLong])

  if (!messageLabel) return null

  return <>
    <CSSBreakpoint max="mobile"><Divider kind="secondary" /></CSSBreakpoint>
    <BodyTextBlock variant="medium" startIcon={messageLabel.icon}>
      {messageLabel.text}
    </BodyTextBlock>
  </>
}

export default withOfferPageAndReduxState((offerPageState) => ({
  offer: (offerPageState.offer ?? offerPageState.bedbankOffer)!,
}))(AccommodationRoomTileMessage)
